<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else class="col_12">
      <div class="d_flex_btwn">
        <h1 class="common_title">
          <span v-if="$route.params.id">Edit Working schedule</span>
          <span v-else>Create a New Working schedule</span>
        </h1>
        <span>
          <router-link :to="{ name: 'working-schedules' }" class="btn btn_black"
            >Back to List</router-link
          >
        </span>
      </div>
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_6 pr_20">
              <div class="row">
                <div class="col_6 pr_20">
                  <div
                    :class="[
                      'form_row_inline',
                      { has_error: errorFor('work_date') },
                    ]"
                  >
                    <label class="required">Date</label>
                    <div class="form_input">
                      <date-picker v-model:input="form.work_date"></date-picker>
                      <v-errors :errors="errorFor('work_date')"></v-errors>
                    </div>
                  </div>
                </div>
                <div class="col_6 pr_20">
                  <div
                    :class="[
                      'form_row_inline',
                      { has_error: errorFor('status') },
                    ]"
                  >
                    <label class="required">Status</label>
                    <div class="form_input">
                      <select class="form_global" v-model="form.status">
                        <option value="pending">Pending</option>
                        <option value="in_progress">In progress</option>
                        <option value="completed">Completed</option>
                      </select>
                      <v-errors :errors="errorFor('status')"></v-errors>
                    </div>
                  </div>
                </div>
                <div class="col_6 pr_20">
                  <div
                    :class="[
                      'form_row_inline',
                      { has_error: errorFor('start_time') },
                    ]"
                  >
                    <label class="required">Start time</label>
                    <div class="form_input">
                      <time-picker
                        v-model:input="form.start_time"
                      ></time-picker>
                      <v-errors :errors="errorFor('start_time')"></v-errors>
                    </div>
                  </div>
                </div>
                <div class="col_6 pr_20">
                  <div
                    :class="[
                      'form_row_inline',
                      { has_error: errorFor('end_time') },
                    ]"
                  >
                    <label class="required">End time</label>
                    <div class="form_input">
                      <time-picker v-model:input="form.end_time"></time-picker>
                      <v-errors :errors="errorFor('end_time')"></v-errors>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col_6 pl_20">
              <div
                :class="[
                  'form_row_inline',
                  { has_error: errorFor('project_title') },
                ]"
              >
                <label class="required">Project name</label>
                <div class="form_input">
                  <input
                    type="project_title"
                    class="form_global"
                    v-model="form.project_title"
                  />
                  <v-errors :errors="errorFor('project_title')"></v-errors>
                </div>
              </div>
              <div
                :class="[
                  'form_row_inline',
                  { has_error: errorFor('description') },
                ]"
              >
                <label class="">Details</label>
                <div class="form_input">
                  <textarea
                    type="text"
                    class="form_global"
                    rows="5"
                    v-model="form.description"
                  ></textarea>
                  <v-errors :errors="errorFor('description')"></v-errors>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col_6">
              <div class="form_row_inline">
                <label></label>
                <div class="form_input">
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="update"
                    v-if="$route.params.id"
                  >
                    Update
                  </button>
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="submit"
                    v-else
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderMaskComponent from '@/components/LoaderMaskComponent.vue';
import DatePicker from '@/components/shared/DatePicker';
import TimePicker from '@/components/shared/TimePicker';
export default {
  name: 'schedule-form',
  components: { LoaderMaskComponent, DatePicker, TimePicker },
  data() {
    return {
      lyLoading: false,
      form: {
        work_date: '',
        start_time: '',
        end_time: '',
        project_title: '',
        description: '',
        status: 'pending',
      },
    };
  },
  created() {
    if (this.$route.params.id) {
      this.loadData(this.$route.params.id);
    }
  },
  computed: {
    duration() {
      if (this.form.start_time && this.form.end_time) {
        const startTime = new Date(`1970-01-01T${this.form.start_time}:00`);
        const endTime = new Date(`1970-01-01T${this.form.end_time}:00`);
        if (endTime > startTime) {
          const diff = (endTime - startTime) / (1000 * 60); // Convert milliseconds to minutes
          return diff;
        }
      }
      return 0;
    },
  },
  methods: {
    loadData(formId) {
      this.lyLoading = true;
      this.axios
        .get('/working-schedules/' + formId)
        .then((response) => {
          this.form = response.data.data;
        })
        .catch(() => {
          this.showFailMsg('No form exists!');
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      // Client-side validation
      const startTime = new Date(`1970-01-01T${this.form.start_time}:00`);
      const endTime = new Date(`1970-01-01T${this.form.end_time}:00`);
      if (startTime >= endTime) {
        this.showFailMsg('End time must be greater than start time.');
        this.lyLoading = false;
        return;
      }

      let formData = new FormData();

      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key] ? this.form[key] : '');
      });

      this.axios
        .post('/working-schedules', formData)
        .then(() => {
          this.resetForm();
          this.showSuccessMsg('Schedule Created Successfully!');
          this.$router.push({ name: 'working-schedules' });
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },

    update() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      formData.append('_method', 'PATCH');

      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key] ? this.form[key] : '');
      });

      this.axios
        .post('/working-schedules/' + this.$route.params.id, formData)
        .then(() => {
          this.showSuccessMsg('Schedule Update Successfully!');
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    resetForm() {
      this.form = {
        work_date: '',
        start_time: '',
        end_time: '',
        project_title: '',
        description: '',
        status: 'pending',
      };
    },
  },
};
</script>
<style scoped>
.create_item_tab button {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.btn_back {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.font_italic {
  position: relative;
  display: block;
  left: 120px;
  padding-top: 5px;
}
</style>
